/**
 * Seed a Set of liked post ids from Social feed payloads that include
 * viewer_has_liked (including nested repost_of embeds).
 */
export function seedLikedFromPosts(posts) {
  const liked = new Set();
  const visit = (p, depth = 0) => {
    if (!p || depth > 2) return;
    const id = p.social_post_id ?? p.post_id ?? p.postId;
    if (id != null && (p.viewer_has_liked || p.viewerHasLiked)) {
      liked.add(String(id));
    }
    if (p.repost_of) visit(p.repost_of, depth + 1);
  };
  for (const p of posts || []) visit(p);
  return liked;
}

/** Merge newly loaded posts' liked flags into an existing Set. */
export function mergeLikedFromPosts(prev, posts) {
  const next = new Set(prev);
  for (const id of seedLikedFromPosts(posts)) next.add(id);
  return next;
}
